import { Component, Input } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div>
  <se-po-overview-card [personaId]="personaId" access="owner">
  </se-po-overview-card>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class OverviewCardExampleComponent {

  constructor() {
  }

}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-overview-card-example',
  template,
  styleUrls: ['./overview-card-docs.component.scss'],
  standalone: false,
})
export class OverviewCardExampleComponent extends SeFeDocsExampleComponent {
  @Input() public personaId: string | number
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  constructor() {
    super()
  }
}
